import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiConstants } from '../shared/constants/api.constant';
@Injectable()
export class UploadService {
  constructor(private httpClient: HttpClient) { }

  /**
   * This function uploads files
   * @param formData: type of FormData and expects form data including files.
   */
  public upload(formData, header) {
    return this.httpClient.post<any>(`${environment.baseScmApiUrl}/${ApiConstants.uploadUrl}`, formData, { headers: header });
  }
}
